var map = {
	"./ai.svg": 2673,
	"./ai1.svg": 26333,
	"./ai3.svg": 68795,
	"./feishu.svg": 35546,
	"./get.svg": 9939,
	"./wallet-icon.svg": 66893,
	"./wallet.svg": 8051
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72608;